import { Tooltip } from "@remo-co/ui-core/src/components/Tooltip";
import { useI18n } from "i18n";
import { ReactComponent as IconSansan } from "./assets/Sansan.inline.svg";

const SansanIcon = () => {
  const { t } = useI18n(["eventForm"]);

  return (
    <Tooltip title={t("eventForm:sansan.profile") as string}>
      <IconSansan />
    </Tooltip>
  );
};

export default SansanIcon;
